/*global kakao*/ 
import { Component } from "react";

class CompMap extends Component{
    componentDidMount() {
        const script = document.createElement("script");
        script.async = true;
        script.src =
          "https://dapi.kakao.com/v2/maps/sdk.js?appkey=4bd17101885ea747448bd0c09621d405&autoload=false";
        document.head.appendChild(script);
    
        script.onload = () => {
          kakao.maps.load(() => {
            let container = document.getElementById("Mymap");
            let options = {
              center: new kakao.maps.LatLng(37.401270, 127.110156),
              level: 2
            };
    
            const map = new window.kakao.maps.Map(container, options); 
            
            let markerPosition = new kakao.maps.LatLng(
              37.401270, 127.110156
            );
        
            let marker = new kakao.maps.Marker({
              position: markerPosition,
            });
        
            marker.setMap(map);
          });
        };        
    }

    render(){
        return(
            <>            
                <div id="Mymap" className="map"></div>
            </>
        );
    }
}

export default CompMap;